/* ===== Осноные компоненты react ===== */
import React, { useState } from "react";

/* ===== Подключение Локальной Базы Данных ===== */
import { navigation } from "../../data";
import ICONS from "../../data/icons";

/* ===== Локальные компоненты ===== */
import BurgerController from "../../components/navigation/BurgerController";
import Nav from "../../components/navigation/Nav";
import PriorityNav from "../../components/ui/PriorityNav/PriorityNav";
import Phone from "../../components/ui/Phone";
import Icon from "../../components/ui/icon/IconsList";
import Button from "../../components/ui/Button/Button";

/* ===== Картинки и прочее ===== */
import logo from "../../assets/images/logo.png";

/* ===== Стили ===== */
import s from "./Header.module.scss";

function Header() {

    /* ===== Достаем нужные иконки из Базы Данных ===== */
    const PhoneIcon = ICONS?.phone?.Icon;

    return (
        <header className={s.header}>
            <div className={s.innerHeader}>
                <div className={s.logoContainer}>
                    <a href="/" className={s.logo}>
                        <img src={logo} alt="Логотип Дизель Гарант" />
                    </a>
                    <span className={s.text}>Москва и Область</span>
                </div>
                <div className={s.navContainer}>
                    <PriorityNav items={navigation} variant="header" />
                </div>
                <div className={s.activContainer}>
                    <div className={s.contactConteiner}>
                        <div className={s.number}>
                            <Phone />
                        </div>
                        <div className={s.social}>
                            <Icon preset="header" />
                        </div>
                    </div>
                    <div className={s.btnConteiner}>
                        <Button
                            type="button"
                            className={s.btn}
                            onClick={() => {
                                document.querySelector("#order-form")?.scrollIntoView({ behavior: "smooth" });
                                setTimeout(() => {
                                    document.querySelector('input[name="phone"]')?.focus();
                                }, 600);
                            }}
                        >
                            Получить цену
                        </Button>
                    </div>
                </div>
                <div className={s.headerBurger}>
                      <a
                        href={ICONS.phone.href}
                        aria-label="Позвонить"
                        className={s.phoneLink}
                    >
                        <PhoneIcon className={s.inlineIcons} />
                    </a>
                    <BurgerController variant="left" title="Меню">
                        {({ closeMenu, resetToken }) => <Nav key={resetToken} onNavigate={closeMenu} resetToken={resetToken} />}
                    </BurgerController>
                </div>
            </div>
        </header>
    );
}

export default Header;